import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { Button, DropdownSelect, Error, TextArea, RadioGroup, RadioInput } from '@figure/frontlib-gui';
import { FEEDBACK_TOPICS } from 'shared/constants/feedback-type';
import { feedbackValidator } from 'shared/validators';

const FeedbackForm = ({ handleSubmit, serverError }) => (
  <Formik
    enableReinitialize
    initialValues={{
      topic: '',
      message: '',
      marketingConsent: false,
    }}
    onSubmit={handleSubmit}
    validationSchema={feedbackValidator}
  >
    {({ values, errors, touched, setFieldValue, handleSubmit }) => (
      <form onSubmit={handleSubmit}>
        <DropdownSelect
          id="topic"
          label="Topic"
          name="topic"
          value={values.topic}
          errorText={touched.topic && errors.topic}
          onChange={(e) => setFieldValue('topic', e.target.value)}
        >
          <option value="" />
          {FEEDBACK_TOPICS.map((t) => (
            <option key={t.value} value={t.value}>
              {t.label}
            </option>
          ))}
        </DropdownSelect>

        <TextArea
          id="message"
          label="Message"
          name="message"
          value={values.message}
          errorText={touched.message && errors.message}
          onChange={(e) => setFieldValue('message', e.target.value)}
          maxLength={1000}
        />

        <RadioGroup label="Do you give Figure Lending LLC permission to use the content of your feedback and your first name and first initial of last name in its marketing materials?">
          <RadioInput
            id="marketing-consent-0"
            label="Yes"
            name="marketing-consent"
            checked={values.marketingConsent}
            required
            onChange={() => setFieldValue('marketingConsent', true)}
          />

          <RadioInput
            id="marketing-consent-1"
            label="No"
            name="marketing-consent"
            checked={!values.marketingConsent}
            required
            onChange={() => setFieldValue('marketingConsent', false)}
          />
        </RadioGroup>

        <Error display="block">{serverError}</Error>

        <Button type="submit" primary large center>
          Send
        </Button>
      </form>
    )}
  </Formik>
);

FeedbackForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  serverError: PropTypes.string.isRequired,
};

export default FeedbackForm;
